const QuantityPlural = {
    install (Vue, options) {
        Vue.filter('quantityPlural', function (word, quantity) {

            switch (word) {
                case 'DAYS': return (quantity > 1 || quantity === 0)? 'werkdagen' : 'werkdag';
                case 'WEEKS': return (quantity > 1 || quantity === 0)? 'werkweken' : 'werkweek';
                case 'PCE': return (quantity > 1 || quantity === 0)? 'stuks' : 'stuk';
                case 'MTR': return 'meter';
                case 'KGM': return (quantity > 1 || quantity === 0)? 'kilogram' : 'kilogram';
                case 'filter': return (quantity > 1)? 'filters' : 'filter';
                case 'optie': return (quantity > 1 || quantity === 0)? 'opties' : 'optie';
            }

        })


    }
}

export default QuantityPlural